import React, { Component } from "react";
import Form from "../../../Form";
import Accordion from "../../Accordion";

class FieldSet extends Component {
  render() {
    const { props } = this;
    return (
      <Accordion
        panels={[
          {
            label: props.label,
            body: (
              <Form
                key={`${props.keyPrefix}`}
                handleInputChange={props.updateForm}
                keyPrefix={`${props.keyPrefix}`}
                schema={props}
                formData={props.formData}
              />
            )
          }
        ]}
      />
    );
  }
}

export default FieldSet;
